<template>
  <div>
    <div class="page">
      <van-row
        class="info-item"
        type="flex"
        justify="space-between"
        align="center"
        @click="chooseDate"
      >
        <van-col class="info-name">日期</van-col>
        <van-col>
          <van-row type="flex" justify="space-between" align="center">
            <van-col class="info-value">{{ dateTime }}</van-col>
            <van-col>
              <img src="../assets/icon_right.png" class="icon-right" />
            </van-col>
          </van-row>
        </van-col>
      </van-row>
      <van-row
        class="info-item"
        type="flex"
        justify="space-between"
        align="center"
      >
        <van-col class="info-name">场馆</van-col>
        <van-col>
          <van-row type="flex" justify="space-between" align="center">
            <van-col class="info-value">{{ gemDetail.venueSubType }}</van-col>
            <van-col>
              <img src="../assets/icon_right.png" class="icon-right" />
            </van-col>
          </van-row>
        </van-col>
      </van-row>
      <van-row
        class="info-item"
        type="flex"
        justify="space-between"
        align="center"
        @click="chooseGem"
      >
        <van-col class="info-name">选择场地</van-col>
        <van-col>
          <van-row type="flex" justify="space-between" align="center">
            <van-col class="info-value">{{ gemName }}</van-col>
            <van-col>
              <img src="../assets/icon_right.png" class="icon-right" />
            </van-col>
          </van-row>
        </van-col>
      </van-row>
      <van-row
        class="info-item"
        type="flex"
        justify="space-between"
        align="center"
        @click="chooseTime"
      >
        <van-col class="info-name">预定时间段</van-col>
        <van-col>
          <van-row type="flex" justify="space-between" align="center">
            <van-col class="info-value">{{ yuyueTime }}</van-col>
            <van-col>
              <img src="../assets/icon_right.png" class="icon-right" />
            </van-col>
          </van-row>
        </van-col>
      </van-row>
    </div>
    <div class="action-area">
      <van-row
        type="flex"
        justify="space-between"
        align="center"
        class="action-content"
      >
        <van-col>
          <van-row type="flex" align="center">
            <van-col class="price-notice">合计</van-col>
            <van-col class="price-value">¥{{ price }}</van-col>
          </van-row>
        </van-col>
        <van-col class="action" @click="doCommit"> 预约 </van-col>
      </van-row>
    </div>
    <van-datetime-picker
      style="width: 100%; position: fixed; bottom: 0"
      v-model="currentDate"
      type="date"
      title="选择年月日"
      :min-date="minDate"
      :max-date="maxDate"
      v-if="showDate"
      @confirm="sureChooseDate"
      @cancel="cancelChooseDate"
    />
    <van-picker
      style="width: 100%; position: fixed; bottom: 0"
      title="时间段"
      show-toolbar
      :columns="timeColumns"
      @confirm="onConfirmTime"
      @cancel="onCancelTime"
      @change="onChange"
      v-if="showTime"
    />
    <van-picker
      style="width: 100%; position: fixed; bottom: 0"
      title="场地"
      show-toolbar
      :columns="gemList"
      @confirm="onConfirmChangdi"
      @cancel="onCancelChangdi"
      v-if="showChangdi"
    />
  </div>
</template>

<script>
import { subGemList } from "@/api/api";
import { subGemPrice } from "@/api/api";
import { creatOrder } from "@/api/api";
import { gemDetail } from "@/api/api";
import { getUserInfo } from "@/api/api";
import { Toast } from "vant";
export default {
  name: "order-info",
  data() {
    return {
      orgGemList: [],
      orgTimeList: [],
      subGemId: "",
      gemId: this.$route.query.gemId,
      showChangdi: false,
      dateTime: "",
      currentDate: new Date(),
      showDate: false,
      showTime: false,
      minDate: new Date(2020, 6, 1),
      maxDate: new Date(2020, 6, 30),
      yuyueTime: "",
      timeColumns: ["08:00-10:00", "10:00-12:00", "15:00-16:00"],
      gemName: "",
      gemList: [],
      price: 0,
      priceId: "",
      gemDetail: [],
      jjrqid: "",
      mflx: "",
      priceType: "",
    };
  },
  created() {
    const nowDate = new Date();
    let date = {
      year: nowDate.getFullYear(),
      month: nowDate.getMonth() + 1,
      date: nowDate.getDate(),
    };
    this.dateTime = "";
    this.dateTime = this.dateTime + date.year + "-";
    if (date.month < 10) {
      this.dateTime = this.dateTime + "0" + date.month + "-";
    } else {
      this.dateTime = this.dateTime + date.month + "-";
    }
    if (date.date < 10) {
      this.dateTime = this.dateTime + "0" + date.date;
    } else {
      this.dateTime = this.dateTime + date.date;
    }
    this.maxDate = new Date(date.year, date.month, date.date - 1);
    this.minDate = new Date(date.year, date.month - 1, date.date);
    // this.dateTime = date.year + '-' + 0 + date.month + '-' + 0 + date.date;
    this.getGemDetail();
    this.getSubGems();
  },
  methods: {
    getGemDetail() {
      let params = {
        id: this.gemId,
      };
      gemDetail(params).then((res) => {
        if (res.code == 0) {
          this.gemDetail = res.data.venue;
        }
      });
    },
    getSubGems() {
      let params = {
        id: this.gemId,
      };
      subGemList(params).then((res) => {
        if (res.code == 0) {
          this.orgGemList = res.data.venueSubList;
          this.gemList = [];
          this.subGemId = res.data.venueSubList[0].id;
          this.gemName = res.data.venueSubList[0].name;
          for (let i = 0; i < res.data.venueSubList.length; i++) {
            const info = res.data.venueSubList[i];
            console.log(info);
            this.gemList.push(info.name);
          }
          this.getGemPrice();
        }
      });
    },
    getGemPrice() {
      let params = {
        id: this.gemId,
        venueSubId: this.subGemId,
        appointTime: this.dateTime,
      };
      subGemPrice(params).then((res) => {
        if (res.code == 0) {
          this.orgTimeList = res.data.timeList;
          this.timeColumns = [];
          this.yuyueTime =
            this.orgTimeList[0].startTime + "-" + this.orgTimeList[0].endTime;
          this.price = this.orgTimeList[0].price;
         this.jjrqid = this.orgTimeList[0].jjrqid;
          this.mflx = this.orgTimeList[0].mflx;
          this.priceType = this.orgTimeList[0].priceType;
          this.priceId = this.orgTimeList[0].id;
          this.subGemId = this.orgTimeList[0].venueSubId;
          for (let i = 0; i < this.orgTimeList.length; i++) {
            this.timeColumns.push(
              this.orgTimeList[i].startTime + "-" + this.orgTimeList[i].endTime
            );
          }
        }
      });
    },
    chooseDate() {
      this.showDate = true;
    },
    sureChooseDate(value) {
      this.dateTime = this.timeFormat(value);
      console.log(this.dateTime);
      this.showDate = false;
      this.getGemPrice();
    },
    cancelChooseDate() {
      this.showDate = false;
    },
    timeFormat(time) {
      // 时间格式化 2019-09-08
      let year = time.getFullYear();
      let month = time.getMonth() + 1;
      let day = time.getDate();
      return year + "-" + month + "-" + day;
    },
    chooseTime() {
      this.showTime = true;
    },
    onConfirmTime(value) {
      this.yuyueTime = value;
      for (let i = 0; i < this.orgTimeList.length; i++) {
        if (
          this.orgTimeList[i].startTime + "-" + this.orgTimeList[i].endTime ===
          value
        ) {
            this.jjrqid = this.orgTimeList[i].jjrqid;
          this.mflx = this.orgTimeList[i].mflx;
          this.priceType = this.orgTimeList[i].priceType;
          this.price = this.orgTimeList[i].price;
          this.priceId = this.orgTimeList[i].id;
          this.suvGemId = this.orgTimeList[i].venueSubId;
          break;
        }
      }
      this.showTime = false;
    },
    onCancelTime() {
      this.showTime = false;
    },
    onChange(value) {
      console.log(value)
    },
    onConfirmChangdi(value) {
      this.gemName = value;
      for (let i = 0; i < this.orgGemList.length; i++) {
        if (this.orgGemList[i].name === value) {
          this.subGemId = this.orgGemList[i].id;
          this.getGemPrice();
          break;
        }
      }
      this.showChangdi = false;
    },
    onCancelChangdi() {
      this.showChangdi = false;
    },
    chooseGem() {
      this.showChangdi = true;
    },
    doCommit() {
      getUserInfo().then((res) => {
        console.log(res);
        if (res.code == 0) {
          if (res.data.username && res.data.telephone && res.data.userSfz) {
            this.actionClick();
          } else {
            this.$router.push({
              path: "/usercenter",
            });
          }
        }
      });
    },
    actionClick() {
      let params = {
        appointTime: this.dateTime,
        orderType: 0,
        usePoints: 0,
        venueId: this.gemId,
        // venuePriceId:this.priceId,
        // venuePriceSubId:this.priceId,
        venueTimeId: this.priceId,
        venueSubId: this.subGemId,
        jjrqid: this.jjrqid,
        mflx: this.mflx,
        priceType: this.priceType,
      };
      creatOrder(params).then((res) => {
        if (res.code == 0) {
          console.log(res);
          if (this.price == 0) {
            this.$router.push({ path: "/myorder" });
          } else {
            this.$router.push({
              path:
                "/payinfo?ordernum=" +
                res.data.orderNum +
                "&price=" +
                this.price,
            });
          }
        } else {
          Toast(res.msg);
          this.$router.push({
            path: "/usercenter",
          });
        }
      });
    },
  },
};
</script>

<style scoped>
.page {
  margin-left: 16px;
  margin-right: 16px;
  margin-top: 25px;
}
.info-item {
  width: 100%;
  height: 56px;
  border-bottom: 1px solid #dfdfdf;
}
.info-name {
  font-size: 17px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(40, 43, 49, 1);
  line-height: 24px;
}
.info-value {
  font-size: 17px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(40, 43, 49, 1);
  line-height: 24px;
}
.icon-right {
  width: 6px;
  height: 12px;
  margin-left: 12px;
  display: block;
}
.action-area {
  box-shadow: 0px 0px 11px 0px rgba(153, 153, 153, 0.3);
  width: 100%;
  height: 64px;
  position: fixed;
  bottom: 0;
}
.action-content {
  height: 64px;
  margin-left: 20px;
  margin-right: 20px;
}
.price-notice {
  font-size: 15px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(103, 108, 117, 1);
  line-height: 21px;
}
.price-value {
  font-size: 20px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: rgba(255, 129, 80, 1);
  line-height: 28px;
}
.action {
  width: 156px;
  height: 48px;
  background: rgba(255, 129, 80, 1);
  box-shadow: 0px 2px 8px 0px rgba(255, 129, 80, 0.2);
  border-radius: 25px;
  font-size: 17px;
  font-family: PingFangTC-Semibold, PingFangTC;
  font-weight: 600;
  color: rgba(255, 255, 255, 1);
  line-height: 48px;
  text-align: center;
}
</style>
